import { z } from 'zod';

export const RevisionStatus = z.enum([
  'Draft',
  'PublishingRequested',
  'Publishing',
  'PublishingFailed',
  'Published',
  'Archived',
]);

export type RevisionStatus = z.infer<typeof RevisionStatus>;

export const RevisionStatuses = Object.values(RevisionStatus.Values);
